import { render, staticRenderFns } from "./DataCrisis.vue?vue&type=template&id=e20a3f32&scoped=true"
import script from "./DataCrisis.vue?vue&type=script&lang=js"
export * from "./DataCrisis.vue?vue&type=script&lang=js"
import style0 from "./DataCrisis.vue?vue&type=style&index=0&id=e20a3f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20a3f32",
  null
  
)

export default component.exports